import _ from "underscore";
export default {
  toNumber: function toNumber(str) {
    return parseInt(str, 10);
  },
  toObject: function toObject(key, value) {
    var obj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (key != null) {
      obj[key] = value;
    }

    return obj;
  },
  makeArray: function makeArray(element) {
    if (_.isArray(element)) {
      return element;
    }

    return [element];
  },
  regexEscape: function regexEscape(str) {
    if (!str) {
      return;
    }

    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
  },
  // escape RegExp
  matchesSearchQuery: function matchesSearchQuery(str, query) {
    return !query || (str != null ? str.toLowerCase().match(new RegExp("\\b".concat(this.regexEscape(query != null ? query.toLowerCase() : undefined)))) : undefined);
  },
  getValueWithinRange: function getValueWithinRange(number, min, max) {
    return Math.min(Math.max(min, number), max);
  },
  randomKey: function randomKey(id) {
    var key = Math.round(Math.random() * 100000);

    if (id) {
      key + "_".concat(id);
    }

    return key;
  },
  // not use classList.remove b/c IE9
  removeClassname: function removeClassname(classNames, toRemove) {
    return classNames.replace(new RegExp("(?:^|\\s)".concat("".concat(toRemove), "(?:\\s|$)")), "");
  },
  pick: function pick() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var arrOfKeys = arguments.length > 1 ? arguments[1] : undefined;
    var arr = !Array.isArray(arrOfKeys) ? this.makeArray(arrOfKeys) : arrOfKeys;
    return arr.reduce(function (accum, key) {
      var value = obj[key];

      if (typeof value !== "undefined" && value !== null) {
        accum[key] = value;
        return accum;
      }

      return accum;
    }, {});
  },
  noop: function noop() {},
  debounceEvent: function debounceEvent(callback, time) {
    var interval;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(interval);
      interval = setTimeout(function () {
        interval = null;
        callback.apply(void 0, args);
      }, time);
    };
  }
};